import React, { Component } from 'react';
import { Button } from 'reactstrap';

import App_data from '../../config/App_data';
import language from '../../../assets/languages/language';

const filterByList = ['Unattempted', 'Attempted', 'Flagged'];
export default class SectionReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: [],
    };
  }
  toggleFilter = item => {
    const { filter } = this.state;
    const indexPos = filter.indexOf(item);
    if (indexPos > -1) {
      this.setState({
        filter: filter.filter(i => i !== item),
      });
    } else {
      this.setState({
        filter: [...filter, item],
      });
    }
  };
  render() {
    const { filter } = this.state;
    const {
      dataList,
      onClick,
      showSectionReview,
      flaggedQuesObject,
      attemptedQuesObject,
    } = this.props;

    return (
      <div className={`sidebar-review-wrapper ${showSectionReview ? 'active' : ''}`}>
        {console.log('showSectionReview', showSectionReview)}
        <div className='header-review'>
          <h2>{language.LC().SECTION_REVIEW}</h2>
          <span onClick={onClick}>
            <img
              width='30px'
              src={`${App_data.frontend_url}/img/questions/icon_close.png`}
              alt={'/img/questions/icon_close.png'}
            />
          </span>
        </div>
        <div className='body-review'>
          <h4>{language.LC().FILTER_BY}:</h4>
          <div className='filt-list-wrapper'>
            <button
              className='btn btn-primary small-btn'
              onClick={() => {
                this.setState({
                  filter: [],
                });
              }}
            >
              {language.LC().CLEAR}
            </button>
            <ul>
              {filterByList.map((item, index) => {
                return (
                  <li className='plan_wrapper remove-plan' key={index}>
                    <label className='check_container'>
                      <input
                        type='checkbox'
                        value={item}
                        id={item}
                        checked={filter.indexOf(item) > -1 ? true : false}
                        onChange={e => this.toggleFilter(item)}
                      />
                      <span className='checkmark' /> {item}
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className='qus-tab-wrapper'>
            {dataList.map((item, index) => (
              <Button
                className={`${attemptedQuesObject[item.id] ? 'completed-qus' : ''}
                ${
                  filter.length === filterByList.length ||
                  (filter.includes('Unattempted') && filter.includes('Attempted'))
                    ? ''
                    : filter.includes('Unattempted') && filter.includes('Flagged')
                    ? !attemptedQuesObject[item.id] && flaggedQuesObject[item.id]
                      ? ''
                      : 'd-none'
                    : filter.includes('Attempted') && filter.includes('Flagged')
                    ? attemptedQuesObject[item.id] && flaggedQuesObject[item.id]
                      ? ''
                      : 'd-none'
                    : filter.includes('Unattempted')
                    ? attemptedQuesObject[item.id]
                      ? 'd-none'
                      : ''
                    : filter.includes('Attempted')
                    ? attemptedQuesObject[item.id]
                      ? ''
                      : 'd-none'
                    : filter.includes('Flagged')
                    ? flaggedQuesObject[item.id]
                      ? ''
                      : 'd-none'
                    : ''
                }
                `}
                onClick={() => {
                  this.setState({
                    showSectionReview: false,
                  });
                  this.props.changeQuestion(index);
                }}
              >
                {index + 1}
                {flaggedQuesObject[item.id] ? (
                  <img
                    width='70'
                    src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                    alt='Question'
                  />
                ) : (
                  ''
                )}
              </Button>
            ))}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/SectionReview.jsx